import { getAuthAxios } from "@artprov/design-system";
import { errorService } from "../../../common/utils/functions/error.service.js";

export const getBancos = async (signal = null) => {
    try {
        const response = await getAuthAxios("default").get(
            '/bancos',
            signal ? { signal } : undefined
        );

        return response.data.bancos || [];
    } catch (error) {
        if (error.response?.status === 404) {
            return [];
        }

        // Para otros errores, manejar normalmente
        errorService.handleError(error, {
            userMessage: "No pudimos obtener la lista de bancos.",
            origen: "getBancos",
        });
        throw error;
    }
};

export const parseBancos = (bancos) => {
    if (!Array.isArray(bancos)) return [];

    return bancos.map(banco => ({
        value: banco.id,           // ID numérico para el backend
        label: banco.nombre,       // Nombre para mostrar en UI
        id: banco.id,             // Mantener por compatibilidad
    }));
};
